import { VumUserRoleClient } from './VumUserRoleClient';
import { DevicePlatform } from '../enums';

export enum VumUserRoleStatus {
    DISABLED_HMI = 'DISABLED_HMI',
    DISABLED_SPIN = 'DISABLED_SPIN',
    DISABLED_PU_SPIN_RESET = 'DISABLED_PU_SPIN_RESET',
    ENABLED = 'ENABLED',
    UNKNOWN = 'UNKNOWN'
}

export class VumUserRoleService {
    constructor(private readonly vumUserRoleClient: VumUserRoleClient) {
    }

    public async getUserRoleStatus(vin: string, devicePlatform: DevicePlatform): Promise<VumUserRoleStatus> {
        const isWcar = devicePlatform === DevicePlatform.WCAR;
        const vumResponse = await this.vumUserRoleClient.getUserRoleStatus(vin, isWcar);
        if (!vumResponse) {
            throw Error("User role status undefined");
        }

        switch (vumResponse.status?.toLowerCase()) {
            case "enabled":
                return VumUserRoleStatus.ENABLED;
            case "disabled_hmi":
                return VumUserRoleStatus.DISABLED_HMI;
            case "disabled_spin":
                return VumUserRoleStatus.DISABLED_SPIN;
            case "disabled_pu_spin_reset":
                return VumUserRoleStatus.DISABLED_PU_SPIN_RESET;
            default:
                return VumUserRoleStatus.UNKNOWN;
        }
    }
}